import { Post } from './../../models/ghost/Post';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the GuideLinkComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'guide-link',
  templateUrl: 'guide-link.html'
})
export class GuideLinkComponent {
  @Input('post') post: Post;

  imageURL: string;
  constructor() {

  }

  ngOnInit(){
    // if(this.post.feature_image){
    //   this.imageURL = `https://blocktistics.com/${this.post.feature_image}`
    // }
  }

}



// WEBPACK FOOTER //
// ./src/components/guide-link/guide-link.ts